import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {confirmAlert} from "react-confirm-alert";
import TextField from "@material-ui/core/TextField";
import API from "@beardeddevops/react.api";
import Types from "../constants/Types";

class Lockable extends Framework.Components.View {

	constructor(props) {
		super(props);

		this.lockModel = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);

		this.doing = null;
		this.doingFor = null;
		this.doingForSystem = false;
		this.state.pin_1 = '';
		this.state.pin_2 = '';
		this.state.pin_3 = '';
		this.state.pin_4 = '';
		this.state.location = '';
		this.state.location_binary_id = '';
		this.state.location_error = '';
		this.state.kiosk = '';
		this.state.kiosk_binary_id = '';
		this.state.kiosk_error = '';
		this.state.kioskName = true;


		//TODO: Auto submit if no pin is needed and only a single location or Kiosk is available anyway.
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (prevState.pin_1 !== this.state.pin_1 ||
			prevState.pin_2 !== this.state.pin_2 ||
			prevState.pin_3 !== this.state.pin_3 ||
			prevState.pin_4 !== this.state.pin_4 ||
			prevState.location !== this.state.location ||
			prevState.location_binary_id !== this.state.location_binary_id ||
			prevState.location_error !== this.state.location_error ||
			prevState.kiosk !== this.state.kiosk ||
			prevState.kiosk_binary_id !== this.state.kiosk_binary_id ||
			prevState.kiosk_error !== this.state.kiosk_error) {
				if (this.doing === 'locking') {
					if (this.state.kioskName) {
						this.handleSetPin(1, false, true );
					}
					else {
						this.handleSetPin();
					}
				} else {
					this.handleUnlockPin();
				}

		}
	}

	handleLock = () => {
		this.lockModel.object.kiosk_mode = this.doingFor;
		this.lockModel.object.pin = this.state.pin_1 + this.state.pin_2 + this.state.pin_3 + this.state.pin_4;
		this.lockModel.object.location = this.state.location;
		this.lockModel.object.location_binary_id = this.state.location_binary_id;
		this.lockModel.object.kiosk = this.state.kiosk;
		this.lockModel.object.kiosk_binary_id = this.state.kiosk_binary_id;
		// noinspection JSIgnoredPromiseFromCall
		this.lockModel.submit(null, this.doingForSystem ? 'GET_LOCK_ALL' : 'GET_LOCK').then(() => {
			let locationID = this.state.location;
			let locationBinaryID = this.state.location_binary_id;

			//Don't trigger a component did update.
			this.doing = null;
			this.doingFor = null;
			this.doingForSystem = false;
			this.state.pin_1 = '';
			this.state.pin_2 = '';
			this.state.pin_3 = '';
			this.state.pin_4 = '';
			this.state.location = '';
			this.state.location_binary_id = '';
			this.state.location_error = '';
			this.state.kiosk = '';
			this.state.kiosk_binary_id = '';
			this.state.kiosk_error = '';
			this.props.rootState.triggerAction('reloadShell');
			if (this.lockModel.object.kiosk_mode === 1) {
				this.props.history.push('/dispositions/one_page/0');
				this.setState({
					pin_1: '',
					pin_2: '',
					pin_3: '',
					pin_4: '',
				});
			}
			if (this.lockModel.object.kiosk_mode === 2) {
				this.props.history.push('/locations/' + locationBinaryID + '-' + locationID);
			}
		});
		return false;
	};

	handleUnlock = () => {
		this.lockModel.object.kiosk_mode = 1;
		this.lockModel.object.pin = this.state.pin_1 + this.state.pin_2 + this.state.pin_3 + this.state.pin_4;
		// noinspection JSIgnoredPromiseFromCall
		this.lockModel.submit(null, this.doingForSystem ? 'DELETE_LOCK_ALL' : 'DELETE_LOCK').then(() => {
			//Don't trigger a component did update.
			this.doing = null;
			this.doingFor = null;
			this.doingForSystem = false;
			this.state.pin_1 = '';
			this.state.pin_2 = '';
			this.state.pin_3 = '';
			this.state.pin_4 = '';
			this.state.location = '';
			this.state.location_binary_id = '';
			this.state.location_error = '';
			this.state.kiosk = '';
			this.state.kiosk_binary_id = '';
			this.state.kiosk_error = '';
			this.props.rootState.triggerAction('reloadShell');

			this.setState({
				pin_1: '',
				pin_2: '',
				pin_3: '',
				pin_4: '',
			});

			if (this.lockModel.object.kiosk_mode === 1) {
				this.props.history.push('/dispositions/pendings');
			}
			//IOI Mode needs locations not dashboard?? - JW
			if (this.lockModel.object.kiosk_mode === 2) {
				this.props.history.push('/locations');
			}

		});
		this.state.pin_1 = '';
		this.state.pin_2 = '';
		this.state.pin_3 = '';
		this.state.pin_4 = '';

		return false;
	};

	handleSystemUnlock = () => {
		// noinspection JSIgnoredPromiseFromCall
		this.lockModel.submit(null, 'DELETE_LOCK_ALL').then(() => {
			//Don't trigger a component did update.
			this.doing = null;
			this.doingFor = null;
			this.doingForSystem = false;
			this.state.pin_1 = '';
			this.state.pin_2 = '';
			this.state.pin_3 = '';
			this.state.pin_4 = '';
			this.state.location = '';
			this.state.location_binary_id = '';
			this.state.location_error = '';
			this.state.kiosk = '';
			this.state.kiosk_binary_id = '';
			this.state.kiosk_error = '';
			this.props.rootState.set({
				isLockedDown: false
			})
			this.props.rootState.triggerAction('reloadShell');
			this.refreshPage();
		});
		return false;
	};

	setPin = (event) => {
		let next = event.target.getAttribute('data-next');
		let newValue = event.target.value;
		if (
			newValue === '' ||
			(parseInt(newValue) >= 0 && newValue.length === 1)
		) {
			this.setState({[event.target.name]: newValue}, () => {
				if (newValue !== '' && next) {
					document.getElementsByName(next)[0].focus();
				}
			});
		}
	};

	handleKeyPress = (onClose) => (event) => {
		let previous = event.target.getAttribute('data-previous');
		if (event.key === 'Enter' && typeof onClose === 'function') {
			if (this.doing === 'locking') {
				this.handleLock();
			} else {
				this.handleUnlock();
			}
			onClose();
		}
		if (event.key === 'Backspace' && previous) {
			document.getElementsByName(previous)[0].focus();
		}
	}

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				this.setState({
					[linked]: object,
					[property]: value,
					[property + '_error']: '',
					[property + '_binary_id']: object.binary_id,
					[property + '_binary_id_error']: '',
				});
			} else {
				this.setState({
					[linked]: object,
					[property]: value,
					[property + '_error']: '',
				});
			}
		} else {
			this.setState({
				[property]: value,
				[property + '_error']: '',
			});
		}
	};


	handleSetPin = (mode, system = false, updating = false, kiosk, kiosk_binary_id, location, location_binary_id) => {
		let {rootState} = this.props;
		this.doing = 'locking';
		if (typeof mode !== 'undefined' && mode) {
			this.doingFor = mode;
			this.doingForSystem = system;
		}
		if (kiosk) {
			this.state.kiosk = kiosk;
			this.state.kiosk_binary_id = kiosk_binary_id;
			this.state.location = location;
			this.state.location_binary_id = location_binary_id;
		}
		if (kiosk || updating ) {
			this.handleSetPinAutoLoadKiosk(1, false, kiosk, kiosk_binary_id, location, location_binary_id);
		}
		else {
			this.state.kioskName = false;
		(this.doingFor === 2 || this.doingFor === 1) && confirmAlert({
			closeOnClickOutside: false,
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert">
						<div className="react-confirm-alert-body">
							<h1>{this.doingFor === 1?'Kiosk Mode':'IOI Mode'}</h1>
							{this.doingFor === 2 && <div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Location</span>
									</div>
									<div className="col-8">
										<Framework.Elements.Select
											shouldLoad={true}
											update={this.handleSelectPropertyUpdate}
											objects={this.props.locations}
											property={this.lockModel.properties.location}
											value={this.state.location}
											binary_id={this.state.location_binary_id}
											error={this.state.location_error}
											text={'name_display|name'}
											// nullable={false}
											filter={
												/** @param {Locations_Properties} option */
													(option) => !option.archived
											}
										/>
									</div>
								</div>
							</div>}
							{this.doingFor === 1 && <div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Kiosk</span>
									</div>
									<div className="col-8">
										<Framework.Elements.Select
											shouldLoad={true}
											update={this.handleSelectPropertyUpdate}
											objects={this.props.kiosks}
											property={this.lockModel.properties.kiosk}
											value={this.state.kiosk}
											binary_id={this.state.kiosk_binary_id}
											error={this.state.kiosk_error}
											text={'name'}
											storeLastSelected={true}
											nullable={false}
										/>
									</div>
								</div>
							</div>}
							<div className={'row'} style={{display: rootState.hasPin?'none':'flex'}}>
								<div className={'col-md'}>
									<TextField
										autoFocus={true}
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_1"
										value={this.state.pin_1}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_2',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_2"
										value={this.state.pin_2}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_1',
											'data-next': 'pin_3',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_3"
										value={this.state.pin_3}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_2',
											'data-next': 'pin_4',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_4"
										value={this.state.pin_4}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress(onClose)}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_3',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
							</div>
							<div style={{justifyContent: 'flex-end'}} className="react-confirm-alert-button-group">
								<div>
									<button onClick={() => {
										this.doing = null;
										this.doingFor = null;
										this.doingForSystem = false;
										this.state.pin_1 = '';
										this.state.pin_2 = '';
										this.state.pin_3 = '';
										this.state.pin_4 = '';
										this.state.location = '';
										this.state.location_binary_id = '';
										this.state.location_error = '';
										this.state.kiosk = '';
										this.state.kiosk_binary_id = '';
										this.state.kiosk_error = '';
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-default'}>Cancel
									</button>
									<button style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-success'}
									        onClick={() => {
										        this.handleLock();
										        onClose();
									        }}
									>
										Lock
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});
		}
	}

		handleSetPinAutoLoadKiosk = (mode, system = false, kiosk, kiosk_binary_id, location, location_binary_id) => {
			let {rootState} = this.props;
			this.state.kioskName = true;
			this.doing = 'locking';
			if (typeof mode !== 'undefined' && mode) {
				this.doingFor = mode;
				this.doingForSystem = system;
			}
			{!rootState.hasPin && confirmAlert({
				closeOnClickOutside: false,
				customUI: ({onClose}) => {
					return (
						<div className="react-confirm-alert">
							<div className="react-confirm-alert-body">
								<h1>{this.doingFor === 1 ? 'Kiosk Mode' : 'IOI Mode'}</h1>
								<div className={'row'} style={{display: rootState.hasPin ? 'none' : 'flex'}}>
									<div className={'col-md'}>
										<TextField
											autoFocus={true}
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_1"
											value={this.state.pin_1}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress()}
											type={'number'}
											inputProps={{
												'data-next': 'pin_2',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_2"
											value={this.state.pin_2}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress()}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_1',
												'data-next': 'pin_3',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_3"
											value={this.state.pin_3}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress()}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_2',
												'data-next': 'pin_4',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
									<div className={'col-md'}>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="pin_4"
											value={this.state.pin_4}
											onChange={this.setPin}
											onKeyUp={this.handleKeyPress(onClose)}
											type={'number'}
											inputProps={{
												'data-previous': 'pin_3',
												maxLength: 1,
												style: {
													lineHeight: '40px',
													fontSize: '40px',
													textAlign: 'center',
												}
											}}
										/>
									</div>
								</div>
										<div style={{justifyContent: 'flex-end'}} className="react-confirm-alert-button-group">
											<div>
												<button onClick={() => {
													this.doing = null;
													this.doingFor = null;
													this.doingForSystem = false;
													this.state.pin_1 = '';
													this.state.pin_2 = '';
													this.state.pin_3 = '';
													this.state.pin_4 = '';
													this.state.location = '';
													this.state.location_binary_id = '';
													this.state.location_error = '';
													this.state.kiosk = '';
													this.state.kiosk_binary_id = '';
													this.state.kiosk_error = '';
													onClose();
												}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-default'}>Cancel
												</button>
												<button style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-success'}
												        onClick={() => {
													        this.handleLock();
													        onClose();
												        }}
												>
													Lock
												</button>
											</div>
								</div>
							</div>
						</div>

					);
				}
			})}
			if (this.doingFor === 1 && rootState.hasPin) {
				this.state.kiosk_binary_id = kiosk_binary_id;
				this.state.location = location;
				this.state.location_binary_id = location_binary_id;
				this.state.kiosk = kiosk;
				this.handleLock();
			}

	};

	handleUnlockPin = () => {
		this.doing = 'unlocking';
		this.doingFor = null;
		confirmAlert({
			closeOnClickOutside: false,
			customUI: ({onClose}) => {
				return (
					<div className="react-confirm-alert">
						<div className="react-confirm-alert-body">
							<h1>Unlock PIN</h1>
							<div className={'row'}>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_1"
										value={this.state.pin_1}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_2',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_2"
										value={this.state.pin_2}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_3',
											'data-previous': 'pin_1',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_3"
										value={this.state.pin_3}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress()}
										type={'number'}
										inputProps={{
											'data-next': 'pin_4',
											'data-previous': 'pin_2',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
								<div className={'col-md'}>
									<TextField
										fullWidth
										margin="dense"
										variant="outlined"
										name="pin_4"
										value={this.state.pin_4}
										onChange={this.setPin}
										onKeyUp={this.handleKeyPress(onClose)}
										type={'number'}
										inputProps={{
											'data-previous': 'pin_3',
											maxLength: 1,
											style: {
												lineHeight: '40px',
												fontSize: '40px',
												textAlign: 'center',
											}
										}}
									/>
								</div>
							</div>
							<div style={{justifyContent: 'flex-end'}} className="react-confirm-alert-button-group">
								<div>
									<button onClick={() => {
										this.doing = null;
										this.doingFor = null;
										this.doingForSystem = false;
										this.state.pin_1 = '';
										this.state.pin_2 = '';
										this.state.pin_3 = '';
										this.state.pin_4 = '';
										this.state.location = '';
										this.state.location_binary_id = '';
										this.state.location_error = '';
										this.state.kiosk = '';
										this.state.kiosk_binary_id = '';
										this.state.kiosk_error = '';
										onClose();
									}} style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-default'}>Cancel
									</button>
									<button style={{marginRight: '0', marginLeft: '10px'}} className={'btn btn-success'}
									        onClick={() => {
										        this.handleUnlock();
										        onClose();
									        }}
									>
										Unlock
									</button>
								</div>
							</div>
						</div>
					</div>
				);
			}
		});
		let firstPin = document.getElementsByName('pin_1')[0] || null;
		if (firstPin && firstPin.value === '') {
			firstPin.focus();
		}
	};

}

//All things that inherit this have rootState. this should have that access?
export default Lockable;
